export default function Label({ ...props }) {
	return <div className="font-medium text-gray-800 dark:text-gray-200 mb-1" {...props} />;
}
